export default __webpack_public_path__ + "static/media/Teacher.c9817aa4.svg";